/* eslint-disable no-unused-vars */
import { notification } from 'ant-design-vue'
import { $http, http } from '@/utils/http'
import host from '@/utils/host'
import queryString from 'query-string'
import {toLogin} from "../utils/utils";
import { report } from '@/utils/reportError'
export default {
  namespaced: true,
  state: {
    noticeList: [],
    remind: {},
    msgNum: 0
  },
  mutations: {
    setNoticeList(state, list) {
      state.noticeList = list
    },
    setRemind(state, data) {
      state.remind = {...state.remind, ...data}
    },
    setMutation(state, { data, namespace }) {
      state[namespace] = data
    }
  },
  actions: {
    async getTradeInfo({ commit }, params) {
      const url = `//sorderapi.haiziwang.com/sorder-api/BOrder/visitView.do?${queryString.stringify(params)}`
      const res = await $http.get(url)
      if (res.code * 1 === 1) {
        return res.data || {}
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '大服务工作台获取门店经营数据接口异常'
        })
        return {}
      }
    },
    async batchGetTradeInfo({ commit }, params) {
      const url = `//sorderapi.haiziwang.com/sorder-api/BOrder/visitViewBatch.do?${queryString.stringify(params)}`
      const res = await $http.get(url)
      if (res.code * 1 === 1) {
        return res.data || {}
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '大服务工作台批量获取门店经营数据接口异常'
        })
        return {}
      }
    },
    async getTradeByTime({ commit }, params) {
      const url = `//ygj.haiziwang.com/maintenance/index?tag=3&${queryString.stringify(params)}`
      const res = await $http.get(url)
      if (res.code * 1 === 1) {
        return res.data || {}
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '大服务工作台获取门店经营数据接口异常'
        })
        return {}
      }
    },
    // 待办事项
    async getComment({ commit }, param) {
      const url = `//soperationapi.haiziwang.com/soperation-api/bcommentPage/getCommentNumForOpen.do?${queryString.stringify(param)}`
      const res = await $http.get(url)
      if (res.code * 1 === 1) {
        return res.data || {}
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '大服务工作台获取评论接口异常'
        })
        return {}
      }
    },
    async getBarCode({ commit }, { barcode }) {
      const url = `//scaterpapi.haiziwang.com/scaterp-api/caterp/queryOrderByBarcode.do?barcode=${barcode}`
      const res = await $http.get(url)
      if (res.code * 1 === 1) {
        return res
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '大服务工作台根据消费码获取订单接口异常'
        })
        return res
      }
    },
    async confirmConsumer({ commit }, { code, writeoffNum = 1 }) {
      const param = {
        barcode: code, writeoffNum
      }
      const url = `//scaterpapi.haiziwang.com/scaterp-api/caterp/writeoffForBusiness.do?param=${JSON.stringify(param)}`
      const res = await $http.get(url)
      if (res.code * 1 === 1) {
        return res
      } else {
        !res.report && report({
          url,
          params:param,
          res,
          msg: res.msg || '大服务工作台核销消费码接口异常'
        })
        return res
      }
    },
    // async getUnreadMsgCount({ commit}, {customerId}) {
    //   const param = {
    //     customerId,
    //     appCode: 'hzwygj'
    //   }
    //   const url = `//msgbox.haiziwang.com/msgbox-web/msgService/getAmountofUnreadMsg.do?${queryString.stringify(param)}`
    //   const res = await $http.get(url)
    //   if (res.success) {
    //     commit('setMutation', {
    //       data: res.content.result,
    //       namespace: 'msgNum'
    //     })
    //   } else {
    //     report({
    //       url,
    //       res,
    //       msg: '大服务工作台核销消费码接口异常'
    //     })
    //     return res
    //   }
    // },
    // async getMessageByType({ commit }, { customerId, msgType, start = 0, rows, isRead }) {
    //   const param = {
    //     customerId,
    //     appCode: 'hzwygj',
    //     msgType,
    //     start,
    //     rows,
    //     isRead // 0未读，1已读
    //   }
    //   const url = `//msgbox.haiziwang.com/msgbox-web/msgService/queryMsgsByTypeAndIsRead.do?${queryString.stringify(param)}`
    //   const res = await $http.get(url)
    //   if (res.success) {
    //     return res.content.result || []
    //   } else {
    //     notification.error({
    //       message: '错误',
    //       description: res.msg,
    //       duration: 0
    //     })
    //     report({
    //       url,
    //       res,
    //       msg: '大服务工作台核销消费码接口异常'
    //     })
    //     return []
    //   }
    // },
    // async reportReadMsg({commit}, {customerId, msgIds}) {
    //   const param = {
    //     customerId,
    //     msgIds
    //   }
    //   const url = `//msgbox.haiziwang.com/msgbox-web/msgService/reportReadAct.do?${queryString.stringify(param)}`
    //   const res = await $http.get(url)
    //   return res
    // }
  }
}
